export enum RelocationType {
    evenSplit = 5,
    beginningRelocation = 6,
    endingRelocation = 7,
    unevenSplit = 8
}
